import React from 'react';
import Popover from 'components/shared/popover';
import { useToggle } from 'hooks';

const IncorrectAttemptPopover = ({
  incorrectCountText,
  incorrectResponseContent,
}) => {
  const [expanded, toggleExpanded] = useToggle(false);

  return (
    <div className="pos-r">
      <button
        onClick={toggleExpanded}
        tabIndex="0"
        type="button"
        className="OnDemandPracticeConversation-popupButton"
      >
        {incorrectCountText}
      </button>
      {expanded && (
        <Popover position="left" dismissCallback={toggleExpanded}>
          {incorrectResponseContent}
        </Popover>
      )}
    </div>
  );
};

export default IncorrectAttemptPopover;
